import * as React from 'react'
import { IconProps } from './types'

export const BoxtronikIcon: React.FC<IconProps> = ({
  title,
  color = 'white',
  stroke = color,
  svgProps
}) => {
  const strokeWidth = 1 //svgProps?.width ? 48 / Number(svgProps.width) : 1
  // const scale = (48 - strokeWidth) / 48
  return (
    <svg
      {...{
        height: 24,
        width: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
        ...svgProps
      }}
    >
      {title && <title>{title}</title>}
      <g fill="#111111">
        <path
          d="M.5 8.97l7.67 3.46 15.33-6.9"
          {...{ stroke, strokeWidth, fill: 'none' }}
          strokeLinecap="round"
        />
        <path
          d="M8.17 12.42v9.21"
          {...{ stroke, strokeWidth, fill: 'none' }}
          strokeLinecap="round"
        />
        <path
          d="M23.5 14.72L8.17 21.63.5 18.18V8.97l15.33-6.89 7.67 3.45v9.19z"
          {...{ stroke, strokeWidth, fill: 'none' }}
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}